import { useContext } from 'react';

import { EMDRContext, IEMDRContext } from 'context';

export function useEMDR(): IEMDRContext {
  return useContext(EMDRContext)!;
}
